import React, { useState } from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';

import { confirmDialog } from 'primereact/confirmdialog';
import { Dialog } from 'primereact/dialog';
import AddEditAdminDashboardSlider from '../components/AddEditAdminDashboardSlider';
const AdminDashboardSlider = () => {

    const [dialog, setDialog] = useState();
    const [editable, setEditable] = useState();
    const actionTemplate = (rowData) => {
        return (
            <div>
                <Button icon="pi pi-pencil" className="custom-btn-edit" onClick={() => editAction(rowData)}/>
                <Button icon="pi pi-trash" className="custom-btn-delete" onClick={() => { confirm(rowData) }} />
            </div>
        );
    }
    const editAction = (rowData) => {
        setEditable(true);
        setEditable(rowData);
        setDialog(true);
    }
    const accept = (rowData) => {
        return
    }
    const reject = (rowData) => {
        return
    }
    const confirm = (rowData) => {
        confirmDialog({
            header: 'Delete',
            message: 'Are u sure want to delete data',
            accept: () => accept(rowData),
            reject: () => reject(rowData),
            acceptClassName: 'custom-bg',
            rejectClassName: 'custom-white',
        })
    }
    const actionEye = (rowData) => {
        return (
            <div>
                <Button icon="pi pi-eye" className="custom-btn-edit"  />
            </div>
        );
    }

    // Dummy data to ensure at least 4-5 rows
    const dummyData = [
        { id: 1, image: "image1.jpg" },
        { id: 2, image: "image2.jpg" },
        { id: 3, image: "image3.jpg" },
        { id: 4, image: "image4.jpg" },
        { id: 5, image: "image5.jpg" },
    ];
    const onHide = () => {
        setDialog(false)
    }
    return (
        <>
            <Dialog visible={dialog} onHide={onHide}
                header={editable ? "Edit Slider Picture" : "Add Slider Picture"}
                style={{ width: "70vw" }}>
                <AddEditAdminDashboardSlider editable={editable}/>
            </Dialog>
            <div className='card'>
                <div className='grid'>
                    <div className="md:col-8"></div>
                    <div className='md:col-2'>
                        <InputText className="w100" placeholder="Search" />
                    </div>

                    <div className="md:col-2" >
                        <div >
                            <Button className="p-button custom-bg w100" label="Add Slider Picture"  onClick={() => { setEditable(false); setDialog(true) }}  />
                        </div>
                    </div>

                    <div className='md:col-12' >
                        <DataTable
                            value={dummyData} // Use dummy data here
                            scrollable
                            scrollHeight="500px"
                            rows={5}
                            paginator
                        >
                            <Column
                                body={(rowData, index) => {
                                    return index.rowIndex + 1;
                                }}
                                header="Sr. No."
                            />
                            <Column header="Images" body={actionEye} />
                            <Column header="Action" body={actionTemplate} />
                        </DataTable>
                    </div>
                </div>
            </div>
        </>
    );
}

export default AdminDashboardSlider;
